/**
 * Consumer Notification Preferences Page (legacy route)
 *
 * The notification preferences UI now lives inside the Profile page as the
 * `Notifications` tab. This file exists solely as a redirect so existing
 * bookmarks / deep links / email links to `/notifications/preferences`
 * continue to land on the right surface.
 *
 * @see /tmp/design-pass/borrower/specs/profile-and-astor-panel.md (Screen 1)
 * @see components/profile/NotificationsTab.tsx
 */

import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

export default function NotificationPreferencesPage(): ReactElement {
  return <Navigate to="/profile?tab=notifications" replace />;
}
